(() => {
  if (window.ttLogoDesignerReady) return;
  window.ttLogoDesignerReady = true;
  const configurations = new WeakMap();
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };
  const sync = () => {
    document.querySelectorAll('#tt-logo-flow').forEach(flow => {
      const parent = flow.closest('[id^="ProductInformation-"]');
      const dataNode = flow.querySelector('[data-tt-logo-price-data]');
      if (!parent || !dataNode) return;
      let config = configurations.get(dataNode);
      if (!config) {
        try { config = JSON.parse(dataNode.textContent); } catch { return; }
        configurations.set(dataNode, config);
      }
      const selectedTitle = parent.querySelector('input[type="radio"]:checked')?.value;
      const variant = config.variants.find(item => item.title === selectedTitle)
        || config.variants.find(item => item.id === config.initialVariantId);
      if (!variant || !Number.isSafeInteger(variant.price)) return;
      flow.querySelectorAll('[data-tt-sku]').forEach(input => {
        const addon = config.addons.find(item => item.sku === input.dataset.ttSku);
        input.disabled = !addon?.available;
        if (addon) {
          input.dataset.ttPrice = String(addon.price);
          const priceLabel = input.closest('.tt-addon').querySelector('.tt-addon-price');
          setText(priceLabel, new Intl.NumberFormat('nb-NO', {style: 'currency', currency: config.currency}).format(addon.price / 100));
        }
      });
      const isTotal = variant.title.toLowerCase() === 'total';
      flow.classList.toggle('tt-total-selected', isTotal);
      const palette = flow.querySelector('[data-palette] input');
      if (palette) {
        palette.disabled = isTotal || !config.addons.find(item => item.sku === palette.dataset.ttSku)?.available;
        if (isTotal) palette.checked = false;
      }
      const selected = Array.from(flow.querySelectorAll('.tt-addon input:checked:not(:disabled)'));
      const summary = flow.querySelector('[data-tt-logo-summary]');
      if (!summary) return;
      summary.hidden = false;
      const format = new Intl.NumberFormat('nb-NO', {
        style: 'currency', currency: config.currency || 'NOK',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      const money = cents => format.format(cents / 100);
      let total = variant.price;
      let hasQuote = false;
      const rows = [{label: config.labels.package + ' – ' + variant.title, amount: money(variant.price)}];
      selected.forEach(input => {
        const label = input.closest('.tt-addon').querySelector('strong')?.textContent.trim() || input.name;
        const price = input.dataset.ttPrice === 'quote' ? null : Number(input.dataset.ttPrice);
        if (Number.isSafeInteger(price) && price >= 0) {
          total += price;
          rows.push({label, amount: money(price)});
        } else {
          hasQuote = true;
          rows.push({label, amount: config.labels.quote});
        }
      });
      if (isTotal) rows.push({label: config.labels.palette, amount: config.labels.included, included: true});
      const estimateField = flow.querySelector('[data-tt-estimate-value]');
      const quoteField = flow.querySelector('[data-tt-quote-value]');
      if (estimateField) estimateField.value = money(total);
      if (quoteField) {
        quoteField.disabled = !hasQuote;
        quoteField.value = hasQuote ? config.labels.quoteNote : '';
      }
      setText(flow.querySelector('[data-tt-mobile-total]'), money(total));
      const signature = JSON.stringify({rows, total, hasQuote});
      if (summary.dataset.ttState === signature) return;
      summary.dataset.ttState = signature;
      const fragment = document.createDocumentFragment();
      rows.forEach(row => {
        const wrapper = document.createElement('div');
        wrapper.className = 'tt-summary-row' + (row.included ? ' is-included' : '');
        const name = document.createElement('dt');
        name.textContent = row.label;
        const amount = document.createElement('dd');
        amount.textContent = row.amount;
        wrapper.append(name, amount);
        fragment.append(wrapper);
      });
      summary.querySelector('[data-tt-summary-lines]').replaceChildren(fragment);
      setText(summary.querySelector('[data-tt-summary-total]'), money(total));
      summary.querySelector('[data-tt-summary-quote]').hidden = !hasQuote;
    });
  };
  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    const parent = target.closest('[id^="ProductInformation-"]');
    const flow = parent?.querySelector('#tt-logo-flow');
    if (flow && (target.type === 'radio' || target.closest('.tt-addon'))) {
      const acceptance = flow.querySelector('input[name="properties[Godkjent designoppdrag]"]');
      if (acceptance) acceptance.checked = false;
    }
  }, true);
  document.addEventListener('invalid', event => {
    const field = event.target;
    if (!field.closest?.('#tt-logo-flow')) return;
    let ancestor = field.parentElement;
    while (ancestor && ancestor.id !== 'tt-logo-flow') {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
  }, true);
  // Run before Horizon's document-level submit delegate so only one cart request is sent.
  window.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const flow = form.closest('[id^="ProductInformation-"]')?.querySelector('#tt-logo-flow');
    if (!flow || !Array.from(flow.querySelectorAll('input[required]')).some(input => input.form === form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.ttSubmitting === 'true') return;
    const invalid = Array.from(form.elements).find(field => field.willValidate && !field.validity.valid);
    if (invalid) {
      let ancestor = invalid.parentElement;
      while (ancestor && ancestor !== flow) {
        if (ancestor.tagName === 'DETAILS') ancestor.open = true;
        ancestor = ancestor.parentElement;
      }
      invalid.reportValidity();
      return;
    }
    sync();
    const config = configurations.get(flow.querySelector('[data-tt-logo-price-data]'));
    if (!config) return;
    const errorBox = flow.querySelector('[data-tt-cart-error]');
    errorBox.hidden = true;
    const source = new FormData(form);
    const selectedTitle = flow.closest('[id^="ProductInformation-"]').querySelector('input[type="radio"]:checked')?.value;
    const variantId = config.variants.find(item => item.title === selectedTitle)?.id || Number(source.get('id'));
    if (!config.variants.some(item => item.id === variantId)) return;
    const selected = Array.from(flow.querySelectorAll('[data-tt-sku]:checked:not(:disabled)'));
    const addons = selected.map(input => config.addons.find(item => item.sku === input.dataset.ttSku));
    if (addons.some(item => !item?.available)) {
      setText(errorBox, config.labels.addonUnavailable);
      errorBox.hidden = false;
      return;
    }
    const body = new FormData();
    body.append('items[0][id]', String(variantId));
    body.append('items[0][quantity]', '1');
    // Keep each design brief independent, including repeat purchases of one package.
    const group = crypto.randomUUID();
    body.append('items[0][properties][_Designoppdrag]', group);
    const paidNames = new Set(Array.from(flow.querySelectorAll('[data-tt-sku]')).map(input => input.name));
    for (const [name, value] of source.entries()) {
      const match = /^properties\[(.*)\]$/.exec(name);
      if (!match || paidNames.has(name) || name === 'properties[Pris for valgt pakke og tillegg inkl. mva.]') continue;
      if (value instanceof File && !value.size) continue;
      if (typeof value === 'string' && !value.trim()) continue;
      body.append('items[0][properties][' + match[1] + ']', value);
    }
    addons.forEach((addon, index) => {
      const prefix = 'items[' + (index + 1) + ']';
      body.append(prefix + '[id]', String(addon.id));
      body.append(prefix + '[quantity]', '1');
      body.append(prefix + '[parent_id]', String(variantId));
      body.append(prefix + '[properties][_Designoppdrag]', group);
    });
    const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    form.dataset.ttSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');
    buttons.forEach(button => { button.disabled = true; });
    try {
      const response = await fetch(config.addUrl, {method:'POST', body, headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error('Cart rejected');
      window.location.assign(config.cartUrl);
    } catch {
      setText(errorBox, config.labels.cartError);
      errorBox.hidden = false;
      errorBox.scrollIntoView({block:'center', behavior:'smooth'});
      form.dataset.ttSubmitting = 'false';
      form.removeAttribute('aria-busy');
      buttons.forEach(button => { button.disabled = false; });
    }
  }, true);
  document.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  new MutationObserver(sync).observe(document.body, {childList: true, subtree: true});
  sync();
})();


